import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';

export const globaleResolverResolver: ResolveFn<Object | null> = (route, state) => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();

  if (!navigation?.extras) {
    console.error('No navigation extras found in globaleResolver');
    router.navigate(['404']);
    return null;
  }

  // Check for data in either state or info properties
  const navigationData = navigation.extras.state || navigation.extras.info;
  
  if (!navigationData) {
    console.error('No navigation data found in globaleResolver');
    router.navigate(['404']);
    return null;
  }

  return navigationData;
};